import { render, staticRenderFns } from "./EmployeeCertificates.vue?vue&type=template&id=1b32f03a&scoped=true"
import script from "./EmployeeCertificates.vue?vue&type=script&lang=js"
export * from "./EmployeeCertificates.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCertificates.vue?vue&type=style&index=0&id=1b32f03a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b32f03a",
  null
  
)

export default component.exports